import { render } from "./MediathequePostePage.vue?vue&type=template&id=117686cc"
import script from "./MediathequePostePage.vue?vue&type=script&lang=js"
export * from "./MediathequePostePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__